import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import album from './album';
import general from './general';
import breadcrumb from './breadcrumb';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    album,
    general,
    breadcrumb
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js